import React, { createContext, useContext, useMemo } from 'react';

/**
 * A module that mounts Atlas pages and owns its own date window (Gemini
 * Enterprise: a 30-day, per-session window shared by every GE page) provides
 * it here. Inside the scope, useAtlasTimeRange reads and writes the module's
 * window instead of the app-wide Atlas store, so an Atlas page mounted in the
 * module agrees with the module's other pages and never moves Atlas' own
 * window. Outside any scope nothing changes.
 *
 * Optional dateParams pins API bounds even for presets; without it preset behavior is unchanged.
 * value: { rangeKey, dateRange: { start_time, end_time }, setRange(key, range), dateParams? }
 */
const AtlasTimeRangeScopeContext = createContext(null);

export const AtlasTimeRangeScope = ({ rangeKey, dateRange, setRange, dateParams = null, children }) => {
  const value = useMemo(
    () => ({ rangeKey, dateRange, setRange, dateParams }),
    [rangeKey, dateRange, setRange, dateParams],
  );
  return (
    <AtlasTimeRangeScopeContext.Provider value={value}>
      {children}
    </AtlasTimeRangeScopeContext.Provider>
  );
};

export const useAtlasTimeRangeScope = () => useContext(AtlasTimeRangeScopeContext);

export default AtlasTimeRangeScope;
